import { Box, Tab, Tooltip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  tabroot: {
    minWidth: theme.spacing(12),
    maxWidth: theme.spacing(30),
    textTransform: 'none',
    textWrapMode: 'nowrap',
  },
  tabrootCompact: {
    minWidth: theme.spacing(6),
    maxWidth: theme.spacing(8),
  },
  tabSelected: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  tabUnselected: {
    fontWeight: 500,
    color: theme.palette.tab.offselected,
  },
  disabledTab: { opacity: 0.5 },
  enabledTab: { opacity: 1 },
  tooltip: {
    fontSize: '0.8rem',
    whiteSpace: 'pre-line',
    textAlign: 'center',
  },
  badge: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.accent.main,
    color: theme.palette.common.black,
  },
  badgeCompact: {
    fontSize: '1.1rem',
    fontWeight: 600,
  },
}));

type CustomTabtype = {
  code: string;
  text: string;
  value: string;
  currentValue: string;
  disabled?: boolean;
  tooltipTitle?: string;
  compact?: boolean;
};

export const CustomTab = ({
  code,
  text,
  value,
  currentValue,
  disabled,
  tooltipTitle = '',
  compact = false,
  ...props
}: CustomTabtype) => {
  const classes = useStyles();
  return (
    <Tooltip title={tooltipTitle} arrow placement="top" classes={{ tooltip: classes.tooltip }}>
      <div>
        <Tab
          {...props}
          value={value}
          classes={{
            root: clsx(classes.tabroot, { [classes.tabrootCompact]: compact }),
          }}
          disabled={disabled}
          id={`scrollable-auto-tab-${code}`}
          aria-controls={`scrollable-auto-tabpanel-${code}`}
          aria-label={text}
          label={
            <Box
              className={clsx({
                [classes.tabSelected]: currentValue === value,
                [classes.tabUnselected]: currentValue !== value,
                [classes.enabledTab]: !disabled,
                [classes.disabledTab]: disabled,
              })}
            >
              {compact ? (
                <Typography className={clsx(classes.badge, classes.badgeCompact)}>
                  {code}
                </Typography>
              ) : (
                <Typography variant="caption">
                  <Typography variant="caption" className={classes.badge}>
                    {code}
                  </Typography>
                  <br />
                  {text}
                </Typography>
              )}
            </Box>
          }
        />
      </div>
    </Tooltip>
  );
};
